import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import main from '@/pages/main'
import signin from '@/pages/sign_in'
import reset from '@/pages/reset'
import register from '@/pages/register'
import registerend from '@/pages/registerend'
import newslist from '@/pages/news/newslist'
import newslistphoto from '@/pages/news/newslistphoto'
import newsphotoinfo from '@/pages/news/newsphotoinfo'
import newsinfo from '@/pages/news/newsinfo'
import informationinfo from '@/pages/information/informationinfo'
import informationlist from '@/pages/information/informationlist'
import datainfo from '@/pages/data/datainfo'
import datalist from '@/pages/data/datalist'
import linbolist from '@/pages/linbo/linbolist'
import linboinfo from '@/pages/linbo/linboinfo'
import publicinfo from '@/pages/public/publicinfo'
import publiclist from '@/pages/public/publiclist'
import zhazhi from '@/pages/zhazhi/zhazhi'
import linbiaoinfo from '@/pages/linbiao/linbiaoinfo'
import linbiaolist from '@/pages/linbiao/linbiaolist'
import linbiaolists from '@/pages/linbiao/linbiaolists'
import linbiaoinfos from '@/pages/linbiao/linbiaoinfos'
import topic from '@/pages/news/topic'
import topicont from '@/pages/news/topicont'
import oneitem from '@/pages/news/oneitem'
import search from '@/pages/search'
import searchcontent from '@/pages/searchcontent'
import about from '@/pages/about'
import callus from '@/pages/callus'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            title: '中国林业产业官网'
          }
        },
        {
          path: '/searchcontent',
          name: 'searchcontent',
          component: searchcontent,
          meta: {
            title: '搜索结果详情_中国林业产业官网'
          }
        },
        {
          path: '/newslist', // 新闻列表
          name: 'newslist',
          component: newslist,
          meta: {
            title: '头条新闻_新闻中心_中国林业产业官网'
          }
        },
        {
          path: '/newslistphoto', // 图文列表
          name: 'newslistphoto',
          component: newslistphoto,
          meta: {
            title: '图文新闻_新闻中心_中国林业产业官网'
          }
        },
		{
          path: '/newsphotoinfo', // 图文详情
          name: 'newsphotoinfo',
          component: newsphotoinfo,
          meta: {
            title: '详情_新闻中心_中国林业产业官网'
          }
        },
        {
          path: '/newsinfo', // 新闻详情
          name: 'newsinfo',
          component: newsinfo,
          meta: {
            title: '详情_头条新闻_中国林业产业官网'
          }
        },
        {
          path: '/informationinfo', // 资讯详情
          name: 'informationinfo',
          component: informationinfo,
          meta: {
            title: '详情_产业资讯_中国林业产业官网'
          }
        },
        {
          path: '/informationlist', // 资讯列表
          name: 'informationlist',
          component: informationlist,
          meta: {
            title: '产业资讯_中国林业产业官网'
          }
        },
        {
          path: '/datainfo', // 数据库详情
          name: 'datainfo',
          component: datainfo,
          meta: {
            title: '详情_产业数据库_中国林业产业官网'
          }
        },
        {
          path: '/datalist', // 数据库列表
          name: 'datalist',
          component: datalist,
          meta: {
            title: '产业数据库_中国林业产业官网'
          }
        },
        {
          path: '/linbolist', // 林博列表
          name: 'linbolist',
          component: linbolist,
          meta: {
            title: '网上林博会_中国林业产业官网'
          }
        },
        {
          path: '/linboinfo', // 林博详情
          name: 'linboinfo',
          component: linboinfo,
          meta: {
            title: '详情_网上林博会_中国林业产业官网'
          }
        },
        {
          path: '/publicinfo', // 公示详情
          name: 'publicinfo',
          component: publicinfo,
          meta: {
            title: '详情_通知公示_中国林业产业官网'
          }
        },
        {
          path: '/publiclist', // 公示列表
          name: 'publiclist',
          component: publiclist,
          meta: {
            title: '通知公示_中国林业产业官网'
          }
        },
        {
          path: '/zhazhi', // 杂志列表
          name: 'zhazhi',
          component: zhazhi
        },
        {
          path: '/linbiaoinfo', // 林标详情
          name: 'linbiaoinfo',
          component: linbiaoinfo
        },
        {
          path: '/linbiaolist', // 林标列表
          name: 'linbiaolist',
          component: linbiaolist
        },
        {
          path: '/linbiaolists', // 产品资讯列表
          name: 'linbiaolists',
          component: linbiaolists
        },
        {
          path: '/linbiaoinfos', // 产品
          name: 'linbiaoinfos',
          component: linbiaoinfos
        },
        {
          path: '/topic', // 专题列表
          name: 'topic',
          component: topic,
          meta: {
            title: '专题新闻_新闻中心_中国林业产业官网'
          }
        },
        {
          path: '/topicont', // 专题内容
          name: 'topicont',
          component: topicont,
          meta: {
            title: '专题详情_专题新闻_中国林业产业官网'
          }
        }, // oneitem
        {
          path: '/oneitem', // 专题内容详情
          name: 'oneitem',
          component: oneitem
        },
        {
          path: '/search', // 专题内容详情
          name: 'search',
          component: search
        },
        {
          path: '/sign_in', // 登陆
          name: 'sign_in',
          component: signin
        },
        {
          path: '/reset', // 重置
          name: 'reset',
          component: reset
        },
        {
          path: '/register', // 注册
          name: 'register',
          component: register
        },
        {
          path: '/registerend', // 注册成功
          name: 'registerend',
          component: registerend
        },
        {
          path: '/registerend', // 注册成功
          name: 'registerend',
          component: registerend
        },
        {
          path: '/about', // 关于我们
          name: 'about',
          component: about
        },
        {
          path: '/callus', // 联系我们
          name: 'callus',
          component: callus
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js